import * as THREE from "three";
import loadingManager from "./loader.js";

export default function materials(scene){
    const textureLoader = new THREE.TextureLoader(loadingManager)

    const ColorTextureWoodLight = textureLoader.load('./textures/wood_light_albedo.jpg')
    ColorTextureWoodLight.colorSpace = THREE.SRGBColorSpace
    ColorTextureWoodLight.wrapT = THREE.RepeatWrapping
    ColorTextureWoodLight.wrapS = THREE.RepeatWrapping

    const materialWoodLight =     new THREE.MeshStandardMaterial({
        map: ColorTextureWoodLight,
    })

    ColorTextureWoodLight.center.set(0.5, 0.5)

    ColorTextureWoodLight.rotation = Math.PI / 2


    const ColorTextureWoodMedium = textureLoader.load('./textures/wood_dark_albedo.jpg')
    ColorTextureWoodMedium.colorSpace = THREE.SRGBColorSpace
    ColorTextureWoodMedium.wrapT = THREE.RepeatWrapping
    ColorTextureWoodMedium.wrapS = THREE.RepeatWrapping

    const materialWoodMedium =     new THREE.MeshStandardMaterial({
        map: ColorTextureWoodMedium,
    })

    ColorTextureWoodMedium.center.set(0.5, 0.5)

    ColorTextureWoodMedium.rotation = Math.PI / 2

    return { materialWoodLight, materialWoodMedium}
}